export const headSort = [
  { text: "Id", field: "id", model: null },
  { text: "Nombre", field: "name", model: null },
  { text: "Dirección", field: "address", model: null },
  { text: "Localidad", field: "city", model: null },
  { text: "Activo", field: "active", model: null },
  { text: "Ranking", field: "ranking", model: null },
  { text: "", field: null, model: null },
];
